import React from 'react';
import { PaginationBar } from '../../components/ui';

interface IPaginationsProps {
  onPreviousClick: () => void;
  onNextClick: () => void;
  isFirstPage: boolean;
  isLastPage: boolean;
  totalRecords: number;
  isDisabled: boolean;
}

const Paginations: React.FC<IPaginationsProps> = (props) => {
  return (
    <PaginationBar
      onPreviousClick={props.onPreviousClick}
      onNextClick={props.onNextClick}
      isFirstPage={props.isFirstPage}
      isLastPage={props.isLastPage}
      totalRecords={props.totalRecords}
      isDisabled={props.isDisabled}
    />
  );
};

export default Paginations;
